module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_01@2x-a079674d05279c1bb81b8a47fc545354.jpg";